import './LayersTOC.css'

export const LayersTOC = () => {
    return (<nav id="menu" />)
}